module.exports = __webpack_public_path__ + "img/cloth_g3_hat-05.f69ae9fd.svg";